import {Injectable} from '@angular/core';
import {SnotifyPosition, SnotifyService} from 'ng-snotify';
import { BehaviorSubject, finalize, throttleTime, timeout } from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {TelegramService} from '../../../pages/page-telegram/telegram.service';
import {AllMessengersService} from '../../../pages/page-start/all-messengers.service';
import {NotifierWrapService} from '../../../services/notifier-wrap.service';
import {AllService} from '../../../services/all.service';
import {IMessage} from '../../../services/websocket';
import {IMessengerConnector, Profile} from '../../../types/all.type';
import {InterfaceService} from '../../../services/interface.service';
import {DcService} from '../../../services/dc.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  mode$: BehaviorSubject<'Старт' | 'Авторизация' | 'Восстановление' | 'Регистрация' | 'Аренда'> = new BehaviorSubject('Старт');
  constructor(
    private dcService: DcService,
    private telegramService: TelegramService,
    private allMessengersService: AllMessengersService,
    private notifierWrapService: NotifierWrapService,
    private allService: AllService,
    private snotifyService: SnotifyService,
    public interfaceService: InterfaceService
  ) {
    this.interfaceService.logout$.subscribe((Service) => {
      if (Service) {
        this.logout(Service);
      }
    });
    /*setTimeout(() => {
      alert(this.telegramService.token);
      this.showError(this.telegramService.token);

    }, 3000);*/
    this.allService.wsService.on<IMessage>('banned').pipe().subscribe((data) => {
      if (data.token) {
        this.showError(data.token);
      } else {
        this.notifierWrapService.notify('error', 'Ошибка. сообщите нам. код ошибки: 1', SnotifyPosition.centerTop, 50000);
      }
    });

    // Restore telegram accounts
    this.allService.wsService.on<IMessage>('authorize_tokens_v2').pipe(throttleTime(60000)).subscribe((data) => {
      if (data.tokens?.length > 0) {

        const inNotHasProfile = this.allMessengersService.arServices.find((v) => v.isAuth && !v.arProfile?.id);
        const process = (() => {
          console.log('Restore accounts');
          data.tokens.forEach((token) => {
            let Service = this.allMessengersService.arServices.find((v) => (v.arProfile?.id?.toString() === token.id.toString()));
            console.log('getServicesFilter', Service, token);
            if (!Service) {
              if (token?.authorized) {
                Service = this.allMessengersService.arServices.find((v) => !v.isAuth && v instanceof TelegramService);
                if (Service instanceof TelegramService) {
                  console.log('Restore account', token);
                  Service.setToken(token.token);
                  Service.setAuth();
                  Service.arProfile = {
                    is_self: true,
                    name: token.name,
                    phone_number: token.phone_number,
                    status: 'online',
                    username: token.username,
                    id: token.id
                  };
                  Service.setVarLocal('profile', Service.arProfile);
                  Service.isLoadedProfile = false;
                  Service.loadProfile().subscribe(() => {
                    this.notifierWrapService.notify('success',
                      `Произошло восстонволение аккаунта ${token.phone_number}. Это хорошо.`,
                      SnotifyPosition.centerTop, 10000);
                  }, error => {
                    /*this.errorService.errorHandling(error, true, Service);*/
                    this.notifierWrapService.notify('warning',
                      `Аккаунт не востановлен ${token.phone_number}.`,
                      SnotifyPosition.centerTop, 10000);
                    this.cdUpdate();
                  });
                }
              }
            }
          });
        });
        if (inNotHasProfile) {
          this.allMessengersService.getProfile()
            .pipe(
              timeout(60000),
              debounceTime(5000),
              finalize(() => {
                process();
              }),
            )
            .subscribe(() => {
              // Код, выполняемый для каждого элемента потока
            });
        }else{
          process();
        }

      }
    }, error => {
      console.error('gp getServicesFilter', error);
    });
    this.duplicateLogout();
  }

  public showError(token: string) {
    return;
    const arServices = this.allMessengersService.getServicesFilter('token', token);
    console.log('getServicesFilter', arServices, token);
    let phone = '';

    if (arServices.length > 0) {
      try {
        this.logout(arServices[0]);
        this.cdUpdate();
        console.log('getServicesFilter logout', arServices[0].type);

      } catch (e) {
        console.error('getServicesFilter ERROR');
      }
      if (arServices[0]?.arProfile?.phone_number) {
        phone = arServices[0].arProfile.phone_number?.toString() || '';
      }
    }
    if (this.allMessengersService.arServicesAuthorized?.length === 0) {
      this.notifierWrapService.notify('error',
        `Аккаунт ${phone} телеграм забанен, что бы вернуться в интерфейс добавьте новый аккаунт на форме входа в этом браузере в форме входа. Аккаунт отключен от интерфейса.`,
        SnotifyPosition.centerTop, 50000);
    } else {
      this.notifierWrapService.notify('error',
        `Один из аккаунтов ${phone} телеграм забанен, рекумендуем добавить еще. Аккаунт отключен от интерфейса.`,
        SnotifyPosition.centerTop, 50000);
    }
  }
  public logout(Service: IMessengerConnector): boolean {
    console.warn('All logout', Service.type);

    localStorage.removeItem(`auth_${Service.type}`);
    delete Service._openChatId;
    delete Service.token;
    delete this.allService._openChatId;
    Service.logout(false);
    if (!this.interfaceService.isTelesellerDomain) {
      this.allService.arChat = this.allService.arChat.filter((v) => v.service_type !== Service.type);
    }else{
      this.allService.arChat = this.allService.arChat.filter((v) => v.service_type !== Service.type || v.type === 'private');
    }
    this.allService.arContacts = this.allService.arContacts.filter((v) => v.service_type !== Service.type);
    try {
      this.allService.saveLocalChats$.next();
      this.allService.saveLocalContacts();
    }catch (e) {
      console.error(e);
    }
    Service.arProfile = ({} as Profile);
    /*const token = localStorage.getItem('token');
    if (this.allService.demoToken === token) {
      localStorage.removeItem('token');
    }*/
    this.notifierWrapService.playAudio('delete');
    this.allService.logout$.next();
    this.cdUpdate();
    return true;
  }

  private duplicateLogout() {
    setTimeout(() => {
      const services = this.allMessengersService.getServicesFilter('isAuth', true);
      const duplicateServices = services.filter((service, index) => {
        return service.arProfile?.id && services.findIndex(s => s.arProfile?.id === service.arProfile?.id) !== index;
      });
      this.snotifyService.clear();
      if (duplicateServices.length > 0) {
        this.snotifyService.confirm(
          `У вас найдено ${duplicateServices.length} дубликатов, удалить их?`,
          'Найдены дубликаты телеграм аккаунтов',
          {
            timeout: 30000,
            titleMaxLength: 100,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            position: SnotifyPosition.centerTop,
            buttons: [
              {
                text: 'Удалить',
                action: () => {
                  duplicateServices.forEach((v) => {
                    this.logout(v);
                  });
                  this.notifierWrapService.notify('info', `Удалено ${duplicateServices.length} дубликатов аккаунтов.`);
                },
                bold: false
              },
              {
                text: 'Нет'
              }
            ]
          }
        );
      }
    }, 15000);
  }
  cdUpdate(): void {
    this.dcService.detectChanges$.next('chat-show');
    this.dcService.detectChanges$.next('app-root');
    this.dcService.detectChanges$.next('navbar');
    this.dcService.detectChanges$.next('profile');
  }
}

